import { Document, Folder, Paginated } from '@quadminds/client-apis/agents';
import { rest } from 'msw';
import { AGENTS_API_URL } from '../../config';
import { generateDocumentListFaker } from '../fixtures/document.faker';
import { generateAgentInteractionFaker } from '../fixtures/knowledge.faker';

export const knowledgeHandler = [
    rest.post(AGENTS_API_URL + '/knowledge/assistant', (req, res, ctx) => {
        const body = req.body as { query?: string };
        return res(ctx.status(200), ctx.json({ ...generateAgentInteractionFaker(), query: body.query ?? '' }));
    }),
    rest.post(AGENTS_API_URL + '/knowledge/v2/assistant', (req, res, ctx) => {
        const body = req.body as { query?: string }; // Explicitly type req.body
        return res(
            // Respond with a 200 status code
            ctx.status(200),
            ctx.json({ ...generateAgentInteractionFaker(), query: body.query ?? '', request_id: '' }),
        );
    }),
    rest.post(AGENTS_API_URL + '/knowledge/assistant/:requestId/cancel', (req, res, ctx) => {
        return res(
            ctx.status(200),
            ctx.json({
                cancelled: true,
                request_id: req.params['requestId'],
            }),
        );
    }),
    rest.post(AGENTS_API_URL + '/knowledge/assistant/:requestId/cancel', (req, res, ctx) => {
        return res(
            ctx.status(200),
            ctx.json({
                cancelled: true,
                request_id: req.params['requestId'],
            }),
        );
    }),
    rest.get(AGENTS_API_URL + '/knowledge/documents', async (req, res, ctx) => {
        const limit = req.url.searchParams.get('limit');
        const page = req.url.searchParams.get('page');
        // Delay manual
        const documents: Document[] = generateDocumentListFaker(Number(limit));
        await new Promise((resolve) => setTimeout(resolve, 2000));
        const response: Paginated<Document, Folder> = {
            data: documents,
            folders: [
                {
                    id: '6846f51dc76b917b4ae9a9fd',
                    name: 'carpeta de prueba david 4',
                    type: 'folder',
                    created_at: '2025-06-09T14:52:13.406000',
                    updated_at: '2025-06-09T14:52:13.406000',
                    parent_id: undefined,
                    owner_id: '635abb5474b9d697a439f581',
                    uploaded_by: {
                        userId: '635abb5474b9d697a439f581',
                        fullName: 'David Carrillo',
                    },
                    organization_id: '635abb4c74b9d697a439f4ac',
                    child_count: 0,
                },
            ],
            pagination: { page: Number(page), page_size: Number(limit), total_documents: 100, total_pages: 10 },
            meta: {
                total_folders: 10,
                total_documents: 90,
                path: [],
            },
        };

        return res(ctx.status(200), ctx.json(response)); // simulate success
        // return res(ctx.status(400), ctx.json(response)); // simulate error
    }),
];
